module.exports = __webpack_public_path__ + "img/MTR.1f8ed5ac.svg";